/** @jsxImportSource @emotion/react */
import React from "react";
import { DatesSelector } from "components/dates-selector/DatesSelector";

export const DateTimeSelector = ( { fromDate, toDate, onChangeFromDate, onChangeToDate }: { fromDate?: number; toDate?: number; onChangeFromDate: ( fromDate: number ) => void; onChangeToDate: ( toDate: number ) => void; } ): JSX.Element => ( <>
  <DatesSelector helpId="dateDates" fromDate={ fromDate } toDate={ toDate } onChangeFromDate={ onChangeFromDate } onChangeToDate={ onChangeToDate } />
</> );
